import type { FaireProductEntity } from "../../entity_types/product";

export const bath_1: FaireProductEntity = {
  token: "bath-1",
  type: "product",
  name: "Lavender Soap Bar",
  brandName: "Pure Soap Co.",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/81e61382f9157e0e28a8c44c69ac1859d7a16c4524e699b09c8a4d39c773bdf5.webp",
  priceDollars: 8,
  msrpDollars: 14,
  freeShipping: true,
  isBestseller: true,
  description: "",
  categoryTokens: ["cat_beauty-all"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
